// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1xioX","consentsList":"PatientConsents_consentsList__2_ykH","consentsListEmpty":"PatientConsents_consentsListEmpty__3JZoB"};